// @flow
import styled from "styled-components";
import colors from '../../assets/css/colors';

export const TableGridHeading = styled.div.attrs({
	role: 'row'
})`
	display: grid;
	grid-template-columns: ${({ columns }) => columns || 'auto'};
	height: ${({ height }) => height || 'auto'};
	background-color: ${colors.nrlDarkGreen};
	align-items: center;

	> div:first-child {
		padding-left: 20px;
	}
`;

export default TableGridHeading;


// WEBPACK FOOTER //
// ./src/components/Table/TableGridHeading.js